// Typeahead over the practice's People list for the recipient of a letter.
// Same shape as the "To" suggestions on the Session email modal
// (EditSession.jsx): a plain text input, suggestions in a list-group under
// it, mousedown to pick so the input's blur does not close the list first.
// Free text still works; the list is a shortcut, not a constraint.
import React, { useState } from "react";
import { Form } from "react-bootstrap";

// Mirrors the Type select on People/AddPersonInline.jsx.
export const PERSON_TYPE_LABELS = {
  GP: "General Practitioner",
  Cardio: "Cardiologist",
  Derm: "Dermatologist",
  Endo: "Endocrinologist",
  Gastro: "Gastroenterologist",
  Neuro: "Neurologist",
  Onco: "Oncologist",
  Ortho: "Orthopaedic Surgeon",
  Pead: "Paediatrician",
  Phys: "Physician",
  Psych: "Psychiatrist",
  Pulmo: "Pulmonologist",
  ENT: "ENT Specialist",
  Eye: "Ophthalmologist",
  Radio: "Radiologist",
  Patho: "Pathologist",
  Physio: "Physiotherapist",
  OT: "Occupational Therapist",
  Biokineticist: "Biokineticist",
  Dietician: "Dietitian",
  Speech: "Speech Therapist",
  Audio: "Audiologist",
  Psychologist: "Clinical Psychologist",
  Chiro: "Chiropractor",
  Podiatrist: "Podiatrist",
  Nurse: "Nurse",
  Pharma: "Pharmacist",
  Dentist: "Dentist",
};

export const personDisplayName = (p) =>
  `${p?.title ?? ""} ${p?.firstName ?? ""} ${p?.lastName ?? ""}`.replace(/\s+/g, " ").trim();

// What goes in "Practice or discipline" when a person is picked.
export const personDetail = (p) => PERSON_TYPE_LABELS[p?.type] || "";

const personKey = (p) => p?._id?.$oid || p?._id || `${p?.firstName}-${p?.lastName}`;

export default function RecipientSearch({ value, onChange, onPick, people, placeholder }) {
  const [open, setOpen] = useState(false);
  const q = String(value || "").trim().toLowerCase();

  const suggestions = open && q.length >= 1
    ? (people || [])
      .filter((p) => {
        const hay = [personDisplayName(p), personDetail(p), p?.hpcsaNumber].filter(Boolean).join(" ").toLowerCase();
        return hay.includes(q);
      })
      .slice(0, 8)
    : [];

  return (
    <div className="position-relative">
      <Form.Control
        type="text"
        autoComplete="off"
        placeholder={placeholder}
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {suggestions.length > 0 && (
        <div
          className="list-group position-absolute w-100 shadow-sm"
          style={{ zIndex: 1056, maxHeight: 240, overflowY: "auto" }}
        >
          {suggestions.map((p) => (
            <button
              key={personKey(p)}
              type="button"
              className="list-group-item list-group-item-action py-2"
              onMouseDown={(e) => { e.preventDefault(); onPick(p); setOpen(false); }}
            >
              <div className="fw-semibold text-truncate">{personDisplayName(p)}</div>
              <div className="small text-muted text-truncate">
                {[personDetail(p), p?.hpcsaNumber && `HPCSA ${p.hpcsaNumber}`].filter(Boolean).join(", ")}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
